import React, { useState } from 'react';
import Pdf from './placeholder3.png'; // fallback dummy image
import ProfilePic from "../assests/imgs/Profileplaceholder.svg";

const ProfileImageWithFallback = ({ url, className, style={} }) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const imageSource = url && !imageError ? url : ProfilePic;

  return (
    <img
      src={imageSource}
      className={className}
      onError={handleImageError}
      alt="preview"
      style={style}
    />
  );
};

export default ProfileImageWithFallback;
